const Zixun  = () => import('@/views/zixun/zixun');
const ZixunDetail = () => import(`@views/zixun/detail/zixun-detail`);


const info = {
  path: '/zixun/:id',
  name: 'zixun',
  component: Zixun,
  meta: {
    pathID: [1]
  },
  children: [{
    path: 'zixun-project/:projectId',
    name: 'zixun-project',
    component: () => import(`@views/zixun/zixun-project/zixun-project`),
    meta:{
      tabBar: false
    },
    children: [{
      path: 'detail/:article_id',
      name: 'zixun-project-detail',
      component: ZixunDetail,
      meta:{
        tabBar: false
      }
    }]
  },{
    path: 'detail/:article_id',
    name: 'zixun-detail',
    component: ZixunDetail,
    meta:{
      tabBar: false
    }
  }]
};

export default info ;